import Student from "@/models/Students/Student";
import _ from "lodash";
import sort from "@/services/sorting";
import { coerce } from "@/lib/array";

import config from "@/config";
import {
  MSGR_MAX,
  MSGR_TG,
  MSGR_TT,
  MSGR_VK,
  STUD_FIELDS_VALS,
  MSGR_VB,
  MSGR_DC,
  CONF_MESSENGER_MAX,
  CONF_MESSENGER_VK,
  CONF_MESSENGER_TG,
  CONF_MESSENGER_VB,
  CONF_MESSENGER_TT,
  CONF_MESSENGER_DISCORD,
  CONF_CLEINT_LOGO_PREFIX,
  CONF_DEFAULT_FILTER_LIST,
} from "@/constants";

import router from "@/routes";
import store from "@/store";

import { ActiveTableConfig } from "@/components/Ui/ActiveTable/BZCore/ActiveTable";
import { ActiveFieldOptions } from "@/components/Ui/ActiveForm/BZCore/ActiveField";
import { TableOptions } from "@/components/Ui/ActiveForm/BZCore/Table/Table";

import StringField from "@/components/Ui/ActiveForm/BZCore/Fields/StringField";
import NumberField from "@/components/Ui/ActiveForm/BZCore/Fields/NumberField";
import SelectField, {
  SelectFieldOptions,
} from "@/components/Ui/ActiveForm/BZCore/Fields/SelectField";

import StudentIndexColumn from "@/components/Students/Table/StudentIndexColumn.vue";
import StudentDetailRow from "@/components/Students/Table/StudentDetailRow.vue";
import StudentStatus from "@/components/Students/Table/StudentStatus.vue";

import FirstName from "@/components/Students/Table/cols/firstName.vue";
import LastName from "@/components/Students/Table/cols/lastName.vue";
import MiddleName from "@/components/Students/Table/cols/middleName.vue";
import Messengers from "@/components/Students/Table/cols/messengers.vue";
import StudentsForm from "@/components/Students/Table/cols/form.vue";
import Depart from "@/components/Students/Table/cols/depart.vue";
import Filial from "@/components/Students/Table/cols/filial.vue";
import MagProgram from "@/components/Students/Table/cols/magProgram.vue";
import AspProgram from "@/components/Students/Table/cols/aspProgram.vue";
import Citizen from "@/components/Students/Table/cols/citizen.vue";
import Hostel from "@/components/Students/Table/cols/hostel.vue";
import SyncTime from "@/components/Students/Table/cols/syncTime.vue";
import Qualif from "@/components/Students/Table/cols/qualif.vue";
import Competition from "@/components/Students/Table/cols/competition.vue";
import Status from "@/components/Students/Table/cols/status.vue";
import Faculty from "@/components/Students/Table/cols/faculty.vue";
import Course from "@/components/Students/Table/cols/course.vue";
import Group from "@/components/Students/Table/cols/group.vue";
import Financing from "@/components/Students/Table/cols/financing.vue";
import Program from "@/components/Students/Table/cols/program.vue";
import Term from "@/components/Students/Table/cols/term.vue";
import State from "@/components/Students/Table/cols/state.vue";
import HalfYear from "@/components/Students/Table/cols/halfYear.vue";
import Semester from "@/components/Students/Table/cols/semester.vue";
import Specialty from "@/components/Students/Table/cols/specialty.vue";
import IsAuth from "@/components/Students/Table/cols/isAuth.vue";

import passBtnComponent from "@/components/Students/Table/passBtn.vue";

import { Message } from "element-ui";

// @ts-ignore
import messages from "@/lang/index";

const StudentsActiveTableConfig: ActiveTableConfig<Student> = {
  documentsName: messages.students.students1,
  indexColumnComponent: StudentIndexColumn,
  defaultPageSize: 20,
  onRowClick({ row }) {
    router.push({ name: "studentPage", params: { id: row.getId() } });
  },
  async find(search, filters, sortKeys, limit, offset) {
    let emptyKeys: string[] = [];
    for (let key in filters) {
      if (Array.isArray(filters[key]) && !filters[key].length) {
        emptyKeys.push(key);
        continue;
      }
      if (filters[key] === "") {
        emptyKeys.push(key);
      }
    }
    for (let key of emptyKeys) {
      delete filters[key];
    }

    let sort: string[][] = [];
    if (Object.keys(sortKeys).length) {
      for (const key in sortKeys) {
        sort.push([key, sortKeys[key]]);
      }
    }

    const params = {
      query: filters,
      limit,
      offset,
      sort,
    };
    const result = await store.dispatch("students/findStudents", params);

    return {
      count: result.count,
      list: result.studs,
    };
  },
  async loadFiltersValues() {
    try {
      let filters: { [key: string]: any } = _.cloneDeep(
        await store.dispatch("students/loadFieldVals")
      );

      const optionalFilters = [
        "form",
        "filial",
        "financing",
        "program",
        "term",
        "state",
        "half_year",
        "semester",
        "specialty",
        "gender",
        "foreigner",
        "need_hostel",
        "status",
        "edu_honors",
        "target_enrollment",
        "target_organization",
        "plan_code",
        "plan_cname",
        "type_edu",
        "speciality",
        "citizen",
        "hostel",
        "prog_asp",
        "prog_mag",
        "qualif",
        "competition",
        "status",
        "sync_time",
        "msgrs",
      ];

      const defaultFilterList = config(CONF_DEFAULT_FILTER_LIST);

      if (defaultFilterList) {
        const defaultFilters = defaultFilterList.split(',');

        defaultFilters.forEach((item: any) => {
          if (optionalFilters.includes(item)) {
            const idx = optionalFilters.indexOf(item);

            optionalFilters.splice(idx, 1);
          }
        })
      }

      if (
        config(CONF_CLEINT_LOGO_PREFIX) === "kuban" ||
        config(CONF_CLEINT_LOGO_PREFIX) === "rgsu"
      ) {
        optionalFilters.shift();
      }

      for (const filter in STUD_FIELDS_VALS) {
        if (filters[filter]) {
          try {
            if (
              filter === "group" &&
              config(CONF_CLEINT_LOGO_PREFIX) === "kuban"
            ) {
              filters[filter] = _(
                filters[filter].map(function(item: any) {
                  return Number(item);
                })
              )
                .sortBy()
                .value();
              filters[filter] = filters[filter].map(function(item: any) {
                return item.toString();
              });
            } else {
              if (STUD_FIELDS_VALS[filter].sort) {
                filters[filter] = coerce(filters[filter], STUD_FIELDS_VALS[
                  filter
                ].sort as string[] | number[]);
              }
            }
          } catch (error) {
            console.error("loadFiltersValues -> coerce", error);
            continue;
          }
          let values = [];
          for (const val of filters[filter]) {
            let label = val;
            if (
              STUD_FIELDS_VALS[filter].dict &&
              STUD_FIELDS_VALS[filter].dict![val]
            ) {
              label = STUD_FIELDS_VALS[filter].dict![val];
            }
            values.push({ label, value: val });
          }

          let optional = optionalFilters.some((item) => item === filter);

          this.filtersAndActions.filters[filter] = {
            label: STUD_FIELDS_VALS[filter].label,
            type: SelectField,
            options: {
              values,
              multiSelect: true,
            },
            optional,
          } as ActiveFieldOptions<SelectFieldOptions>;
        } else {
          let optional = optionalFilters.some((item) => item === filter);
          this.filtersAndActions.filters[filter] = {
            label: STUD_FIELDS_VALS[filter].label,
            type: SelectField,
            options: {
              values: [],
              multiSelect: true,
              disabled: true,
            },
            placeholder: messages.labels.no_data,
            optional,
          } as ActiveFieldOptions<SelectFieldOptions>;
        }
      }

      // const REQUIRED_MIN = 4;
      // const nonOptionalCount = Object.values(this.filtersAndActions.filters).filter(f => !f.optional).length;
      // console.log(1, nonOptionalCount, Object.values(this.filtersAndActions.filters).filter(f => !f.optional))
      // if (nonOptionalCount < REQUIRED_MIN) {
      //   let needed = REQUIRED_MIN - nonOptionalCount;
      //   console.log(4, needed)
      //   for (const key of Object.keys(this.filtersAndActions.filters)) {
      //     if (needed <= 0) break;
      //     if (this.filtersAndActions.filters[key].optional) {
      //       this.filtersAndActions.filters[key].optional = false;
      //       needed--;
      //     }
      //   }
      // }

      this.filtersAndActions.filters.msgrs = {
        label: messages.labels.cols.messengers,
        type: SelectField,
        options: {
          values: [],
          multiSelect: true,
        },
        optional: true,
      } as ActiveFieldOptions<SelectFieldOptions>;

      if (this.getActiveSocial(CONF_MESSENGER_MAX)) {
        this.pushSocial('MAX', MSGR_MAX);
      }
      if (this.getActiveSocial(CONF_MESSENGER_VK)) {
        this.pushSocial(messages.common.socials.vk, MSGR_VK);
      }
      if (this.getActiveSocial(CONF_MESSENGER_TG)) {
        this.pushSocial(messages.common.socials.tg, MSGR_TG);
      }
      if (this.getActiveSocial(CONF_MESSENGER_VB)) {
        this.pushSocial(messages.common.socials.vb, MSGR_VB);
      }
      if (this.getActiveSocial(CONF_MESSENGER_TT)) {
        this.pushSocial(messages.common.socials.tt, MSGR_TT);
      }
      if (this.getActiveSocial(CONF_MESSENGER_DISCORD)) {
        this.pushSocial(messages.common.socials.dc, MSGR_DC);
      }

      if (this.filtersAndActions.filters.for_all) {
        delete this.filtersAndActions.filters.for_all;
      }
    } catch (error) {
      console.error("loadFiltersValues", error);
    }
  },
  getActiveSocial(key: string) {
    return config(key) && config(key) === true;
  },
  pushSocial(name: string, value: string) {
    this.filtersAndActions.filters.msgrs.options.values.push({
      label: name,
      value: value,
    });
  },
  filtersAndActions: {
    pageName: messages.labels.search_and_filters,
    searchFormButtonText: messages.labels.search_form_button_text,
    headerButtons: [passBtnComponent],
    searchForm: {
      inputs: {
        last_name: {
          type: StringField,
          label: messages.labels.cols.last_name,
        },
        first_name: {
          type: StringField,
          label: messages.labels.cols.first_name,
        },
        middle_name: {
          type: StringField,
          label: messages.labels.cols.middle_name,
        },
        email: {
          type: StringField,
          label: messages.labels.email,
        },
        login: {
          type: StringField,
          label: messages.labels.login,
        },
      },
      steps: [
        { map: [["last_name", "first_name", "middle_name", "email", "login"]] },
      ],
    },
    filters: {},
  },
  defaultShownColumns: ["last_name", "first_name", "middle_name", "messengers"],
  table: {
    cols: {
      last_name: {
        label: messages.labels.cols.last_name,
        component: LastName,
        sortable: true,
      },
      first_name: {
        label: messages.labels.cols.first_name,
        component: FirstName,
        sortable: true,
      },
      middle_name: {
        label: messages.labels.cols.middle_name,
        component: MiddleName,
        sortable: true,
      },
      messengers: {
        label: messages.labels.cols.messengers,
        component: Messengers,
      },
      id: {
        label: messages.labels.cols.main_id,
        isModel: true,
        sortable: false,
      },
      pid: {
        label: messages.labels.cols.p_id,
        isInStud: true,
        sortable: false,
      },
      guid: { label: messages.labels.cols.id, isInStud: true, sortable: false },
      kub_id: {
        label: messages.labels.cols.kub_id,
        isInStud: true,
        sortable: false,
      },
      form: {
        label: messages.labels.cols.form,
        component: StudentsForm,
        sortable: true,
      },
      depart: {
        label: messages.labels.cols.depart,
        component: Depart,
        sortable: true,
      },
      filial: {
        label: messages.labels.cols.filial,
        component: Filial,
        sortable: true,
      },
      mag_program: {
        label: messages.labels.cols.mag_program,
        component: MagProgram,
        sortable: true,
      },
      asp_program: {
        label: messages.labels.cols.asp_program,
        component: AspProgram,
        sortable: true,
      },
      qualif: {
        label: messages.labels.cols.qualif,
        component: Qualif,
        sortable: true,
      },
      competition: {
        label: messages.labels.cols.competition,
        component: Competition,
        sortable: true,
      },
      status: {
        label: messages.labels.cols.status,
        component: Status,
        sortable: true,
      },
      citizen: {
        label: messages.labels.cols.citizen,
        component: Citizen,
        sortable: true,
      },
      hostel: {
        label: messages.labels.cols.hostel,
        component: Hostel,
        sortable: true,
      },
      sync_time: {
        label: messages.labels.cols.sync_time,
        component: SyncTime,
        sortable: true,
      },
      faculty: {
        label: messages.labels.cols.faculty,
        component: Faculty,
        sortable: true,
      },
      course: {
        label: messages.labels.cols.course,
        component: Course,
        sortable: true,
      },
      group: {
        label: messages.labels.cols.group,
        component: Group,
        sortable: true,
      },
      financing: {
        label: messages.labels.cols.financing,
        component: Financing,
        sortable: true,
      },
      program: {
        label: messages.labels.cols.program,
        component: Program,
        sortable: true,
      },
      term: {
        label: messages.labels.cols.term,
        component: Term,
        sortable: true,
      },
      state: {
        label: messages.labels.cols.state,
        component: State,
        sortable: true,
      },
      half_year: {
        label: messages.labels.cols.half_year,
        component: HalfYear,
        sortable: true,
      },
      semester: {
        label: messages.labels.cols.semester,
        component: Semester,
        sortable: true,
      },
      specialty: {
        label: messages.labels.cols.specialty,
        component: Specialty,
        sortable: true,
      },
      is_auth: {
        label: messages.labels.cols.is_auth,
        component: IsAuth,
        sortable: true,
      },
    },
    detailRowComponent: StudentDetailRow,
  } as TableOptions,
};
export default StudentsActiveTableConfig;
